import DoubleColumn from "../../molecules/DoubleColumn";
import { useSelector } from "react-redux";
import { getFoodData } from "../../../store/food/selectors";
import {
  Card,
  CardBody,
  CardHeader,
  Heading,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import useFoods from "../../../utils/hooks/useFood";
import AvailableSoon from "../../molecules/AvailableSoon";

export default function Food() {
  useFoods();
  const foods = useSelector(getFoodData);

  return (
    <DoubleColumn>
      {((foods?.length === 0 ?? true) || !foods?.some((food) => food.show)) && (
        <AvailableSoon />
      )}
      {foods?.map((food) => {
        if (food.show) {
          return (
            food.show && (
              <Card key={food.id ?? food.title}>
                <CardHeader>
                  <Heading size={"md"}>{food.title}</Heading>
                </CardHeader>
                <CardBody>
                  <Text whiteSpace="pre-line">{food.description}</Text>
                  {food.website && (
                    <Link href={food.website}>{food.website}</Link>
                  )}
                  {food.logoUrl && (
                    <Image
                      src={food.logoUrl}
                      w="100%"
                      maxH="300px"
                      objectFit="contain"
                      mt={2}
                    />
                  )}
                </CardBody>
              </Card>
            )
          );
        } else {
          return null;
        }
      })}
    </DoubleColumn>
  );
}
